import React, { useEffect, useRef, useState } from 'react';
import { loadDaumPostcode, normalizeDaumAddress } from '../utils/daumPostcode';

/**
 * 다음(카카오) 우편번호 공개 API 임베드 모달.
 * 기존 모달(z-50) 위에서 열리도록 z-[60] 사용.
 */
const DaumPostcodeModal = ({ open, onClose, onSelect }) => {
  const wrapRef = useRef(null);
  const onCloseRef = useRef(onClose);
  const onSelectRef = useRef(onSelect);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    onCloseRef.current = onClose;
    onSelectRef.current = onSelect;
  }, [onClose, onSelect]);

  useEffect(() => {
    if (!open) return undefined;

    let cancelled = false;
    setError('');
    setLoading(true);

    (async () => {
      try {
        const Postcode = await loadDaumPostcode();
        if (cancelled || !wrapRef.current) return;
        wrapRef.current.innerHTML = '';

        new Postcode({
          oncomplete: (data) => {
            onSelectRef.current?.(normalizeDaumAddress(data));
            onCloseRef.current?.();
          },
          onclose: (state) => {
            if (state === 'FORCE_CLOSE') onCloseRef.current?.();
          },
          width: '100%',
          height: '100%',
        }).embed(wrapRef.current);

        if (!cancelled) setLoading(false);
      } catch (e) {
        if (!cancelled) {
          setLoading(false);
          setError(e?.message || '주소 검색을 열 수 없습니다.');
        }
      }
    })();

    return () => {
      cancelled = true;
      if (wrapRef.current) wrapRef.current.innerHTML = '';
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-40 p-4">
      <div className="bg-white rounded-lg shadow-lg w-[92vw] max-w-lg overflow-hidden flex flex-col" style={{ height: 'min(560px, 85vh)' }}>
        <div className="shrink-0 flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <h3 className="text-sm font-semibold text-gray-900">주소 검색</h3>
          <button
            type="button"
            className="text-sm text-gray-500 hover:text-gray-800"
            onClick={() => onCloseRef.current?.()}
          >
            닫기
          </button>
        </div>
        {error && (
          <div className="shrink-0 px-4 py-2 text-xs text-red-600 bg-red-50 border-b border-red-100">
            {error}
          </div>
        )}
        {loading && !error && (
          <div className="shrink-0 px-4 py-2 text-xs text-gray-500">주소 검색을 불러오는 중…</div>
        )}
        <div ref={wrapRef} className="flex-1 min-h-0" />
      </div>
    </div>
  );
};

export default DaumPostcodeModal;
